<template v-id="user" src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Multiselect from 'vue-multiselect'

	export default {
		props: ['user', 'isAuth', 'refresh'],
		components: {
			'multiselect': Multiselect,
		},
		data () {
			return {
				roles: null,
				departments: null,
				data: {
					email: null,
					profile: {
						skills: null,
						first_name : null,
						last_name : null,
						phone : null,
						mobile : null,
					}
				},
				roles : [],
				department_id : null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getRoles()
				this.getDepartments()
			},
			getRoles() {
				this.$http.get('admin/roles')
				.then(response => {
					this.roles = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getDepartments() {
				this.$http.get('admin/departments')
				.then(response => {
					this.departments = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			store() {
				var loading = Ladda.create(this.$refs.btnStore);
				loading.start();
				this.$http.post('admin/users', this.data)
				.then(response => {
					var data = response.body.data
					var menu = this.$route.meta.menu
					if(menu == 'dashboard') {
						this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/users/' + data.id + '/edit')
					} else {
						this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/' + menu + '/users/' + data.id + '/edit')
					}
					loading.stop()
					swal({ 
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					loading.stop();
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/users/views/Create.vue